// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"c431a7bf","678":"33eb4dd5","963":"417a707a"}[chunkId] + ".chunk.js";
};